module.exports = __webpack_public_path__ + "img/ejemplo_simulador.d6d3f03f.png";